import React from 'react';

import PropTypes from 'prop-types';

import {
    Image,
    Section,
    Typography,
} from 'wanderu-components';
import appSettings from 'wanderu-config';
import { localize } from 'wanderu-i18n';

import cityToCityConfig from '../../../../config/c2c.locale';

import styles from './RouteMap.scss';

function RouteMap(props) {
    const {
        locationData,
        slug,
        t,
    } = props;
    const src = `${appSettings.config.s3.staticAssetsUrl}cities/routemap/${slug}.png`;

    const mapSummary = t('mapSummary');
    const hasSummaryTranslation = mapSummary !== 'mapSummary';

    return (
        <Section aria-labelledby="route-map-header">
            <Typography
                align="center"
                className={styles.title}
                id="route-map-header"
                variant="h2"
            >
                {t('mapTitle')}
            </Typography>
            <Image
                alt={`${locationData.departure.name} ${locationData.arrival.name}`}
                className={styles.routeMapImage}
                height={200}
                loading="lazy"
                src={src}
                width={310}
            />
            {hasSummaryTranslation && (
                <Typography
                    className={styles.routeMapSummary}
                >
                    {mapSummary}
                </Typography>
            )}
        </Section>
    );
}

RouteMap.propTypes = {
    slug: PropTypes.string.isRequired,
    locationData: PropTypes.shape({
        arrival: PropTypes.shape({
            name: PropTypes.string,
        }),
        departure: PropTypes.shape({
            name: PropTypes.string,
        }),
    }).isRequired,
};

export { RouteMap };
export default localize(RouteMap, cityToCityConfig.namespace);
